import usePermissions from "hooks/usePermissions";
const useSecurityEventEditCondition = () => {
  const { isPermitted } = usePermissions();
  return isPermitted("security_event:edit");
};
export default useSecurityEventEditCondition;
